import LoginContainer from '@/containers/auth/LoginContainer';
import PasswordResetContainer from '@/containers/auth/PasswordResetContainer';
import PasswordRestWithTokenContainer from '@/containers/auth/PasswordRestWithTokenContainer';

export default [
  {
    path: '/',
    name: 'Login',
    alias: '/login',
    component: LoginContainer,
  },
  {
    path: '/forgot',
    name: 'PasswordReset',
    component: PasswordResetContainer,
  },
  {
    path: '/password/:token',
    name: 'PasswordRestWithToken',
    component: PasswordRestWithTokenContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/auth.js